import React, { useContext, useState } from "react";
import axios from "axios";
import FormInput from "../FormInputs/FormInput";
import "../SignupForm/signupForm.scss";
import "./newProductForm.scss";
import { FieldArray, Formik } from "formik";

//assets imports
import warning from "assets/icons/warning.png";
import atomoPlus from "../../../assets/icons/atomoPlus.svg";
import atomoMinus from "../../../assets/icons/atomoMinus.svg";

//Styles
import PageButton from "components/PageButton/PageButton";
import { CurrentUserContext } from "context/UserContext";
import { useHistory } from "react-router-dom";

const validation = (values) => {
  let errors = {};

  if (!values.title) {
    errors.title = "El campo nombre es requerido";
  } else if (values.title.length < 2) {
    errors.title = "Inserte al menos dos letras";
  }
  if (!values.category_id) {
    errors.category_id = "El campo categoría es requerido";
  }
  if (!values.address) {
    errors.address = "El campo dirección es requerido";
  } else if (values.address.length < 2) {
    errors.address = "Inserte al menos dos letras";
  }
  if (!values.location_id) {
    errors.location_id = "El campo ciudad es requerido";
  }
  if (!values.maps_place_id) {
    errors.maps_place_id = "El campo Google Place ID es requerido";
  } else if (values.maps_place_id.length < 2) {
    errors.maps_place_id = "Inserte al menos dos letras";
  }
  if (!values.score) {
    errors.score = "El campo dirección es requerido";
  } else if (`${parseFloat(values.score)}` !== values.score) {
    errors.score = "El valor ingresado debe ser numérico";
  } else if (!Number.isInteger(parseFloat(values.score))) {
    errors.score = "El valor ingresado debe ser entero";
  } else if (values.score < 1 || values.score > 10) {
    errors.score = "Ingrese un valor entre 1 y 10";
  }
  if (!values.description_title) {
    errors.description_title = "El campo título es requerido";
  } else if (values.description_title.length < 2) {
    errors.title = "Inserte al menos dos letras";
  }
  if (!values.description) {
    errors.description = "El campo descripción es requerido";
  } else if (values.description.length < 2) {
    errors.title = "Inserte al menos dos letras";
  }
  if (!values.cover_url) {
    errors.cover_url = "El campo portada es requerido";
  } else if (values.cover_url.length < 2) {
    errors.cover_url = "Inserte al menos dos letras";
  }
  if (values.features.length === 0) {
    errors.features = "Debe ingresar al menos un atributo";
  }

  if (values.images.length < 2) {
    errors.images = "Debe ingresar al menos una imagen";
  }
  return errors;
};

const NewProductForm = () => {
  const [user] = useContext(CurrentUserContext);
  const history = useHistory();
  const [errorState, setErrorState] = useState(false);

  const newProduct = async (
    title,
    description_title,
    description,
    score,
    address,
    maps_place_id,
    category_id,
    location_id,
    images,
    features
  ) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products`,
        {
          title,
          description_title,
          description,
          score,
          address,
          maps_place_id,
          category_id,
          location_id,
          images,
          features,
        },
        { headers: { Authorization: `Bearer ${user.jwt}` } }
      );
      history.push("/admin/product/success");
    } catch (error) {
      setErrorState(true);
      console.log(error.message);
    }
  };

  function normalizeImage(img, isCover, productTitle, num = 0) {
    return {
      url: img.url,
      title: `${productTitle} ${isCover ? "" : `imágen ${num}`}`,
      cover: isCover,
    };
  }

  return (
    <Formik
      initialValues={{
        title: "",
        category_id: null,
        address: "",
        location_id: null,
        maps_place_id: "",
        score: "",
        description_title: "",
        description: "",
        cover_url: "",
        features: [],
        images: [],
      }}
      onSubmit={async (values, actions) => {
        const images = [
          normalizeImage({ url: values.cover_url }, true, values.title),
          ...values.images.map((img, index) =>
            normalizeImage(img, false, values.title, index + 1)
          ),
        ];
        await newProduct(
          values.title,
          values.description_title,
          values.description,
          values.score,
          values.address,
          values.maps_place_id,
          values.category_id,
          values.location_id,
          images,
          values.features
        );
        actions.setSubmitting(false);
        console.log(values);
      }}
      validate={validation}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {/**This props are injected by Formik*/}
      {(props) => <NewProductFormTemplate {...props} errorState={errorState} />}
    </Formik>
  );
};

const NewProductFormTemplate = ({
  handleSubmit,
  isSubmitting,
  handleChange,
  values,
  errors,
  errorState,
}) => {
  //CATEGORIES
  const [categories, setCategories] = React.useState([]);

  //API TO GET CATEGORIES
  React.useEffect(() => {
    const fetchCategories = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/categories`
        );
        setCategories(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchCategories();
  }, []);

  //LOCATIONS
  const [locations, setLocations] = React.useState([]);

  //API TO GET LOCATIONS
  React.useEffect(() => {
    const fetchLocations = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/locations`
        );
        setLocations(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchLocations();
  }, []);

  //POLICIES
  const [policies, setPolicies] = React.useState({
    documentation: "",
    coverage: "",
    cancellation: "",
  });

  //API TO GET POLICIES
  React.useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/policies/1`
        );
        setPolicies(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchPolicies();
  }, []);

  const regex = /<p>/gi;
  const regex2 = /<\/p>/gi;
  const policiesDocumentation = policies.documentation
    .replace(regex, "")
    .replace(regex2, "\n\n");

  const policiesCoverage = policies.coverage
    .replace(regex, "")
    .replace(regex2, "\n\n");

  const policiesCancellation = policies.cancellation
    .replace(regex, "")
    .replace(regex2, "\n\n");
  console.log(errors);
  return (
    <form className="newProductForm" onSubmit={handleSubmit}>
      {errorState && (
        <div className="errorProductCharge">
          <img src={warning} alt="warning" />
          <p>
            {" "}
            Lamentablemente no ha podido cargarse el producto. Por favor,
            intente más tarde
          </p>
        </div>
      )}
      <div className="newProductForm__dataInput__productInfo__container">
        <FormInput name="title" type="text" label="Nombre del vehículo" />
        <div className="newProductForm__container__form__select">
          <label>Categoría</label>
          <select
            onChange={handleChange}
            value={values.category}
            name="category_id"
            className={errors.category_id ? "error" : ""}
          >
            <option value="placeholder"></option>
            {categories.map((category) => (
              <option value={category.id} key={category.id}>
                {category.title}
              </option>
            ))}
          </select>
          {errors.category_id && <p>{errors.category_id}</p>}
        </div>
        <FormInput name="address" type="text" label="Dirección" />
        <div className="newProductForm__container__form__select">
          <label>Ciudad</label>
          <select
            onChange={handleChange}
            value={values.start_time}
            name="location_id"
            className={errors.location_id ? "error" : ""}
          >
            <option value="placeholder"></option>
            {locations.map((location) => (
              <option value={location.id} key={location.id}>
                {location.city}, {location.country}
              </option>
            ))}
          </select>
          {errors.location_id && <p>{errors.location_id}</p>}
        </div>
        <FormInput name="maps_place_id" type="text" label="Google Place ID" />
        <FormInput name="score" type="text" label="Score" />
      </div>
      <div className="newProductForm__dataInput__description__container">
        <FormInput name="description_title" type="text" label="Título" />
        <FormInput
          textarea
          placeholder="Escriba aquí"
          name="description"
          label="Descripción"
        />
      </div>
      <div className="newProductForm__dataInput__features">
        <h2>Agregar atributos</h2>
        <FieldArray
          name="features"
          render={(arrayHelpers) => (
            <div className="newProductForm__dataInput__features__container">
              {values.features.map((feature, index) => (
                <div
                  className="newProductForm__dataInput__features__container__individual"
                  key={index}
                >
                  <div>
                    <FormInput
                      name={`features.${index}.description`}
                      type="text"
                      label="Descripción"
                    />
                    <FormInput
                      name={`features.${index}.icon`}
                      type="text"
                      label="Ícono"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <img src={atomoMinus} alt="minusIcon" />
                  </button>
                </div>
              ))}
              <button
                className="plusButton"
                type="button"
                onClick={() => arrayHelpers.push({ description: "", icon: "" })}
              >
                <img src={atomoPlus} alt="plusIcon" />
                <span>Agregar atributo</span>
              </button>
              {errors.features && <p>{errors.features}</p>}
            </div>
          )}
        />
      </div>

      <div className="newProductForm__dataInput__policies">
        <h2>Políticas del producto</h2>
        <div className="newProductForm__dataInput__policies__container">
          <div className="newProductForm__dataInput__policies__individual__container">
            <h3>Documentación a presentar</h3>
            <FormInput
              textarea
              value={policiesDocumentation}
              readOnly
              name="documentation"
              label="Descripción"
            />
          </div>
          <div className="newProductForm__dataInput__policies__individual__container">
            <h3>Coberturas y garantías</h3>
            <FormInput
              textarea
              value={policiesCoverage}
              readOnly
              name="coverage"
              label="Descripción"
            />
          </div>
          <div className="newProductForm__dataInput__policies__individual__container">
            <h3>Política de cancelación</h3>
            <FormInput
              textarea
              value={policiesCancellation}
              readOnly
              name="cancellation"
              label="Descripción"
            />
          </div>
        </div>
      </div>
      <div className="newProductForm__dataInput__images">
        <h2>Cargar imágenes</h2>
        <div className="newProductForm__dataInput__images__container">
          <FormInput name="cover_url" type="text" label="Portada" />
        </div>
        <FieldArray
          name="images"
          render={(arrayHelpers) => (
            <div className="newProductForm__dataInput__images__container">
              {values.images.map((image, index) => (
                <div
                  className="newProductForm__dataInput__images__container__individual"
                  key={index}
                >
                  <FormInput
                    name={`images.${index}.url`}
                    type="text"
                    label="Descripción"
                  />
                  <button
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <img src={atomoMinus} alt="minusIcon" />
                  </button>
                </div>
              ))}
              <button
                className="plusButton"
                type="button"
                onClick={() =>
                  arrayHelpers.push({ title: "", url: "", cover: false })
                }
              >
                <img src={atomoPlus} alt="plusIcon" />
                <span>Agregar imagen</span>
              </button>
              {errors.images && <p>{errors.images}</p>}
            </div>
          )}
        />
      </div>
      <div className="newProductForm__submitButton__container">
        <PageButton
          filled
          disabled={isSubmitting}
          type="submit"
          label="Crear"
          className="standardWidth"
        />
      </div>
    </form>
  );
};

export default NewProductForm;
